// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".choose-way-title[data-v-3a66be90] {\n  color: #364250;\n  font-weight: 600;\n  font-size: 16px;\n  margin-bottom: 48px;\n}\n.item-container[data-v-3a66be90] {\n  margin-bottom: 30px;\n  cursor: pointer;\n}\n.item-title[data-v-3a66be90] {\n  font-size: 16px;\n  font-weight: 600;\n}\n.item-content[data-v-3a66be90] {\n  font-size: 16px;\n}", ""]);
// Exports
module.exports = exports;
